import React from 'react';

/**
 * Static "Flywheel" section that replaces the Scorecard starting September 1, 2026.
 * Uses `isFlywheelEra(month, year)` to decide whether to render this or ScorecardSection.
 * All data-testids preserved for automated tests.
 */

// Cutover date: any tactical whose (year, month) tuple is >= (2026, 9) is on the
// flywheel layout. Change these two constants if the rollover date shifts.
const FLYWHEEL_ERA_YEAR = 2026;
const FLYWHEEL_ERA_MONTH = 9;

export const isFlywheelEra = (month, year) => {
  if (!month || !year) return false;
  if (year > FLYWHEEL_ERA_YEAR) return true;
  if (year < FLYWHEEL_ERA_YEAR) return false;
  return month >= FLYWHEEL_ERA_MONTH;
};

export const FlywheelSection = () => (
  <section data-testid="flywheel-section">
    <div className="section-header flex items-center gap-2 py-1.5 px-3">
      <span className="text-sm">⚙️</span>
      <span className="text-sm">Flywheel</span>
    </div>
    <div className="p-4 flex items-center justify-center bg-white">
      <img
        src="/images/flywheel.png"
        alt="TMC Growth Flywheel — Attract Empower Engage · Deliver Care · Expand Market Share · Reinvest in Teams Tools Innovation"
        data-testid="flywheel-image"
        className="max-w-full h-auto max-h-[340px] object-contain"
        loading="lazy"
      />
    </div>
  </section>
);
